__turbopack_context__.v({
  "main": "page-module__E0kJGG__main",
});
